import { render } from "./AlteracoesProtocolo.vue?vue&type=template&id=7365ad66&scoped=true"
import script from "./AlteracoesProtocolo.vue?vue&type=script&lang=js"
export * from "./AlteracoesProtocolo.vue?vue&type=script&lang=js"

import "./AlteracoesProtocolo.vue?vue&type=style&index=0&id=7365ad66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7365ad66"]])

export default __exports__